/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOneDrive = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m9.388 8.915 4.619 2.767 2.752-1.159a4.452 4.452 0 0 1 2.074-.354A6.876 6.876 0 0 0 6.429 8.097l.07-.002a5.472 5.472 0 0 1 2.89.82z" />
        <path d="M9.388 8.915a5.472 5.472 0 0 0-2.889-.82l-.07.002a5.497 5.497 0 0 0-4.441 8.644l4.071-1.715 7.948-3.344z" />
        <path d="M18.833 10.169a4.452 4.452 0 0 0-2.073.354l-2.753 1.159 8.458 5.066a4.47 4.47 0 0 0-3.632-6.58z" />
        <path d="m14.007 11.682-7.948 3.344-4.072 1.715a5.493 5.493 0 0 0 4.512 2.356h12.032a4.466 4.466 0 0 0 3.934-2.349z" />
      </g>
    </g>
  </Icon>
);
export { SvgOneDrive as OneDrive };
